import { useGet } from '../../../../api';
import { useEffect } from 'react';
import { downloadFile } from '../../../../components/utils';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';

const IMPORT_APS_FILE_NAME = 'silverfort_import_apps_format.csv';

export type UploadApplicationsFormatDto = {
    responseId: string;
};

export const useGetUploadApplicationsFormat = () => {
    const { data, fetchData, loading } = useGet<UploadApplicationsFormatDto>({
        enabled: false,
        url: `${ACCESS_ANALYSIS_BASE_URL}/applications/generateUploadCsvTemplate`
    });

    useEffect(() => {
        const responseId = data?.responseId;

        if (!loading && responseId) {
            downloadFile(`/users/downloadImportCsvFormat/${responseId}/${IMPORT_APS_FILE_NAME}`);
        }
    }, [data?.responseId, loading]);

    return {
        downloadFormat: fetchData,
        downloadingFormat: loading
    };
};
